var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTime1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "time1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28817",
    "data-name": "Group 28817"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36051",
    "data-name": "Path 36051",
    d: "M32,64A32,32,0,1,0,0,32,32.006,32.006,0,0,0,32,64ZM29.714,13.714a2.286,2.286,0,1,1,4.572,0V30.9L44.857,39.36a2.286,2.286,0,0,1-1.429,4.069,2.249,2.249,0,0,1-1.429-.5L30.572,33.783A2.294,2.294,0,0,1,29.714,32V13.714Z",
    fill: "#6d6d6d"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime1);
export default __webpack_public_path__ + "static/media/time1.0b4b15ab9407f2cd2dd9ce951a9e5b0b.svg";
export { ForwardRef as ReactComponent };